export default {"src":"/_next/static/media/txtevmblue.c7517ea2.svg","height":33,"width":101,"blurWidth":0,"blurHeight":0};